import { Button, Input, Typography } from 'antd'
import React, { useContext, useState } from 'react'
import { MapContext } from '../../App/MapContextContainer';
import Polygon from '@arcgis/core/geometry/Polygon';
import { PREFERRED_WKID } from '../../pages/CustomAreas/UserDataContextContainer';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    margin-top: 1em;
`;

export default function FindForestMaskPiece() {
    const [objectId, setObjectId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const mapContext = useContext(MapContext);
    const { t } = useTranslation("sidePanelTabs");

    const onSearchClicked = () => {
        setIsLoading(true);

        const asyncCall = async () => {
            try {
                let declarationsUrl = "https://rajapinnat.metsaan.fi/geoserver/Avoinmetsatieto/forestmask/wfs" +
                    "?SERVICE=WFS&REQUEST=GetFeature&VERSION=2.0.0&TYPENAMES=Avoinmetsatieto:forestmask&OUTPUTFORMAT=json&SRSNAME=EPSG:4326&propertyName=(geom,area)";

                if (objectId && objectId !== "") {
                    declarationsUrl += `&resourceId=${objectId}`;
                }

                const response = await fetch(declarationsUrl, {
                    method: 'GET'
                });

                const featuresResponse = await response.json();

                console.log(featuresResponse);

                const firstFeature = featuresResponse.features[0];

                if (firstFeature) {
                    const polygon = new Polygon({
                        rings: firstFeature.geometry.coordinates[0],
                        spatialReference: {
                            wkid: PREFERRED_WKID
                        }
                    });

                    mapContext.navigateToPoint(polygon);
                }
            } catch (error) {
            }
            finally {
                setIsLoading(false);
            }
        }

        asyncCall();
    }

    return (
        <Container>
            <Typography.Title level={5}>{t("etsiMetsämaskia")}</Typography.Title>

            <div>{t("etsiMetsämaskiaTunnisteella")}</div>
            <Input size='large' placeholder={t("metsämaskiPlaceHolder")} type='text' onChange={e => setObjectId(e.currentTarget.value)}></Input>

            <Button loading={isLoading} onClick={() => onSearchClicked()}>{t("haeNappula")}</Button>
        </Container>
    )
}